export class AjaxErrorInfo {
  isUnauthorized: boolean;
  isPermissionDenied: boolean;
  isSessionExpired: boolean;
  isServerError: boolean;
  isApplicationError: boolean;
  isConnectionError: boolean;
  serverErrorMessage: string;
  applicationErrorMessage: string;
  applicationErrorDetails: any;
  errorDetails: string;

  constructor() {
    this.isUnauthorized = false;
    this.isPermissionDenied = false;
    this.isSessionExpired = false;
    this.isServerError = false;
    //this.isApplicationError = false;
    this.isConnectionError = false;
    //this.applicationErrorMessage = null;
    this.errorDetails = null;
    //this.applicationErrorDetails = null;
  }
}
